import { IonRow, IonCol } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import CompetitionsMenu from '../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import { clearExchcngeBets, fetchOpenBets, setExchEvent } from '../../store';
import { connect } from 'react-redux';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import ExchBetslip from '../../components/ExchBetslip/ExchBetslip';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {  PlaceBetRequest } from '../../models/BsData';
import { RootState } from '../../models/RootState';
import { UserBet } from '../../models/UserBet';
import { SelectedObj } from '../../models/ExchangeSportsState';
import ExchOpenBets from '../../components/ExchOpenBets/ExchOpenBets';
import ExchOutrightsEventTable from '../../components/ExchOutrightsEventTable/ExchOutrightsEventTable';
import { isIOS } from 'react-device-detect';
import HomeView from '../../constants/HomeView';

type StoreProps = {
  clearExchcngeBets: () => void;
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  totalOrders:number;
  loggedIn: boolean;
  selectedEvent: SelectedObj;
  setExchEvent: (exchEvent: SelectedObj) => void;
  fetchOpenBets: (eventId: string) => void;
};

const ExchOutrightsView: React.FC<StoreProps> = (props) => {
  const {
    clearExchcngeBets,
    bets,
    openBets,
    totalOrders,
    loggedIn,
    selectedEvent,
    setExchEvent,
    fetchOpenBets,
  } = props;
  const [openBetslip, setOpenBetslip] = useState<boolean>(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const Images = HomeView.EVENT_PAGE_IMAGES;

  useEffect(() => {
    clearExchcngeBets();
  }, []);

  useEffect(() => {
    if (!openBetslip && bets.length > 0) {
      setOpenBetslip(true);
    }
  }, [bets]);

  useEffect(() => {
    if (loggedIn && selectedEvent && selectedEvent.id === '28127348') {
      fetchOpenBets(selectedEvent.id);
    }
  }, [loggedIn, selectedEvent]);

  useEffect(() => {
    const exchEventId = '28127348';
    setExchEvent({
      id: exchEventId,
      name: 'IPL',
      slug: 'ipl',
    });
  }, []);

  return (
    <div>
      <div className="exch-outrights-ctn">
        <IonRow className="exch-outrights-view">
          <IonCol className="exch-outrights-competitions-menu-section web-view">
            <div className="sticky-col">
              <CompetitionsMenu loggedIn={loggedIn} />
            </div>
          </IonCol>
          <IonCol className="exch-outrights-table-section">
            <div className="banner-container web-view">
              <img
                className="banner-image"
                src={Images['ipl']?.image}
                key={'inplay-image'}
                alt={'banner'}
                title={'IPL 2021'}
              />
            </div>
            <ExchOutrightsEventTable loggedIn={loggedIn} />
          </IonCol>

          <IonCol className="exch-outrights-betslip-section web-view">
            <div className="sticky-col">
              <Accordion
                className="bs-accordion"
                expanded={openBetslip}
                onChange={(_, expanded) => setOpenBetslip(expanded)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon className="expand-icon" />}
                  aria-controls="panel1a-content"
                  className="bs-header "
                >
                  Bet Slip ({bets.length})
                </AccordionSummary>
                <AccordionDetails className="bs-body">
                  {bets.length > 0 ? <ExchBetslip mobileView={false} /> : null}
                </AccordionDetails>
              </Accordion>
              {loggedIn ? (
                <Accordion
                  className="bs-accordion open-bets-accordion open-bets-ctn"
                  defaultExpanded={true}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon className="expand-icon" />}
                    aria-controls="panel1a-content"
                    className="bs-header"
                  >
                    Open Bets ({totalOrders})
                  </AccordionSummary>
                  <AccordionDetails className="bs-body">
                    {totalOrders > 0 ? <ExchOpenBets /> : null}
                  </AccordionDetails>
                </Accordion>
              ) : null}
            </div>
          </IonCol>
        </IonRow>
      </div>
      <div
        className={isIOS ? 'betslip-section ios-betslip' : 'betslip-section'}
      >
        <Accordion
          className="stream-accordion"
          expanded={openBetslip}
          onChange={(_, expanded) => setOpenBetslip(expanded)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className="expand-icon" />}
            aria-controls="panel1a-content"
            className="stream-header"
          >
            Bet Slip ({bets.length})
          </AccordionSummary>
          <AccordionDetails className="stream-body">
            {bets.length > 0 ? <ExchBetslip mobileView={true} /> : null}
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState, ownProps) => {
  return {
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
    totalOrders: state.exchBetslip.totalOrders,
    loggedIn: ownProps.loggedIn,
    selectedEvent: state.exchangeSports.selectedEvent,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    clearExchcngeBets: () => dispatch(clearExchcngeBets()),
    setExchEvent: (exchEvent: SelectedObj) => dispatch(setExchEvent(exchEvent)),
    fetchOpenBets: (eventId: string) => dispatch(fetchOpenBets(eventId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchOutrightsView);
